import React from 'react';
import { withRouter } from 'react-router-dom';

import { formatDateFromISO } from 'shared/date';
// import { ReactComponent as Share } from 'assets/temp/share.svg';
import { ReactComponent as Clock } from 'assets/icons/clock.svg';
import { ReactComponent as Lock } from 'assets/icons/lock.svg';

import styles from './Article.module.scss';

import { shouldOpenPurchaseModal } from 'utils/inAppPurchaseUtils';
import { useModals } from 'context/modal/useModals';

const Article = ({ data, history, showModal }) => {
    const modals = useModals();
    const navigate = (to = '/home', episode) => {
        episode?.locked
            ? shouldOpenPurchaseModal(
                  episode,
                  modals,
                  () => {
                      showModal('global');
                  },
                  to
              )
            : history.push(to);
    };

    return (
        <div
            className={styles.article}
            onClick={() => navigate(`/articles/${data.id}`, data)}
        >
            <div className={styles.container}>
                {data.locked ? <Lock /> : null}
                <div
                    className={styles.image_container}
                    style={{
                        backgroundImage: `url(${(data.hero_image &&
                            data.hero_image.url) ||
                            (data.thumbnail && data.thumbnail.url)})`,
                    }}
                >
                    {data.locked && <div className={styles.mask}></div>}
                </div>
            </div>
            <div
                className={styles.data}
                style={{ opacity: data.locked ? '0.5' : '1' }}
            >
                <div>
                    <div>{formatDateFromISO(data.date_posted, 'D T Y')}</div>
                    <div>
                        {' '}
                        • <Clock />{' '}
                        {data &&
                            (Math.round(data.time_to_read) === 0
                                ? '1'
                                : Math.round(data.time_to_read))}{' '}
                        min
                    </div>
                </div>
                {/* <div>
					<Share/>
				</div> */}
            </div>
            <div
                className={styles.summary}
                style={{ opacity: data.locked ? '0.5' : '1' }}
            >
                {data.title}
            </div>
        </div>
    );
};

export default withRouter(Article);
